import styled from "styled-components";

export const ButtonWrapper = styled.div`
  position: relative;

  & > div {
    min-width: 24px;
    min-height: 24px;
    width: max-content;
  }

  &:hover > div {
    opacity: 1;
    visibility: visible;
  }

  button {
    position: relative;
    z-index: 1;
    width: 24px;
    height: 24px;

    &.active {
    }
  }
`;

export const DropdownWrapper = styled(ButtonWrapper)<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 2px;
  cursor: pointer;
`;

export const OpacityTextfieldWrapper = styled("div")`
  & input {
    padding: 0;
    width: 46px;
    height: 30px;
    text-align: center;
    border: 1px solid white;
    border-radius: 99;
  }
`;
